;(function () {
  'use strict'

  angular
    .module('contrast.application.protection')
    .factory('AppProtectionService', [
      '$q',
      'ProtectionRulesFactory',
      'ErrorService',
      AppProtectionService
    ])

  function AppProtectionService($q, ProtectionRulesFactory, ErrorService) {
    var _protectionLevelApplied = 0

    var service = {
      editEnvProtectionLevel: editEnvProtectionLevel
    }

    return service

    function editEnvProtectionLevel(configs) {
      if (!angular.isArray(configs)) {
        configs = [configs]
      }
      _protectionLevelApplied = 0
      return _editEnvProtectionLevelAsync(configs).then(function () {
        return {
          protectionLevelApplied: _protectionLevelApplied
        }
      })
    }

    //from http://stackoverflow.com/questions/25704745/how-do-i-sequentially-chain-promises-with-angularjs-q
    function _editEnvProtectionLevelAsync(arr) {
      return arr.reduce(function (promise, item) {
        return promise.then(function (result) {
          return _editEnvProtectionLevel(result, item)
        })
      }, $q.when(''))
    }

    function _editEnvProtectionLevel(result, config) {
      return ProtectionRulesFactory.editEnvProtectionLevel(
        config.appId,
        config.ruleId,
        config.env,
        config.level
      )
        .then(function () {
          _protectionLevelApplied++
        })
        .catch(_processApiError)
    }

    function _processApiError(response) {
      ErrorService.processError(response)
      return response
    }
  }
})()
